module.exports = __webpack_public_path__ + "img/uk.0e2319e2.png";